module.exports = __webpack_public_path__ + "static/media/huawei_recent_1.e32ec809.png";